import { MEETING_WITH_CAREER_PATH_EVALUATION } from '../MeetingQueries'
import { ApolloError, useQuery } from '@apollo/client'
import { MeetingWithCareerPathEvaluationQueryVariables, MeetingWithCareerPathEvaluationQuery } from '../../../types'

export const useMeetingWithCareerPathEvaluation = (
  meetingId: string,
): {
  data: MeetingWithCareerPathEvaluationQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<MeetingWithCareerPathEvaluationQuery, MeetingWithCareerPathEvaluationQueryVariables>(
    MEETING_WITH_CAREER_PATH_EVALUATION,
    {
      variables: {
        meetingId: meetingId,
      },
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
